<template>
  <div class="dialog-container" v-loading="isLoading">
    <el-alert class="mb-3" :title="errorMessage" type="error" show-icon v-if="errorMessage"></el-alert>
    <el-row :gutter="18">
      <el-col :span="24">
        <el-form ref="userSignin" :model="form" :rules="rules" label-width="30%">
          <el-form-item label="Username" prop="username">
            <el-input v-model="form.username" placeholder="Username" @keyup.enter.native="prepareAuth"></el-input>
          </el-form-item>
          <el-form-item label="Password" prop="password">
            <el-input type="password" v-model="form.password" placeholder="Password"
              @keyup.enter.native="prepareAuth"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row :gutter="18" class="dialog-footer">
      <el-col :span="24" class="align-right">
        <el-button @click="closeDialog" v-if="user.id === -1">Cancel</el-button>
        <el-button type="primary" @click="prepareAuth">Sign In</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import get from 'lodash/get';
import { Required, Password } from '@/util/formValidators';

export default {
  data() {
    return {
      isLoading: false,
      errorMessage: '',
      form: {
        username: null,
        password: null,
      },
      rules: {
        username: [Required],
        password: [Required, Password],
      },
    };
  },
  computed: {
    ...mapGetters('User', ['user']),
  },
  methods: {
    ...mapActions('User', ['authenticate']),
    async prepareAuth() {
      this.errorMessage = '';
      try {
        await this.$refs.userSignin.validate();
      } catch {
        // form not valid
        return;
      }

      this.isLoading = true;
      try {
        await this.authenticate({
          Username: this.form.username.toLowerCase(),
          Password: this.form.password,
        });

        this.closeDialog();
      } catch (e) {
        // TODO: if login failed and the user is an admin, give them a password reset option
        console.error('Login error', e);
        const detailMessage = get(e, 'response.data', e.message || '');
        this.errorMessage = `Login Failed. Please try again. ${detailMessage}`;
      } finally {
        this.isLoading = false;
      }
    },
    closeDialog() {
      this.form.username = null;
      this.form.password = null;
      this.isLoading = false;
      this.errorMessage = '';
      this.$nextTick(() => {
        this.$refs.userSignin.resetFields();
      });
      this.$emit('close');
    },
  },
};

</script>
